import script from "./ClientLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientLayout.vue?vue&type=script&setup=true&lang=js"

import "./ClientLayout.vue?vue&type=style&index=0&id=f196e356&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f196e356"]])

export default __exports__